import { LoginRoutingModule, routedComponents } from './login.routing';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { SharedModelModule } from '../shared-model/shared-model.module';
import { NgxLoadingModule } from "ngx-loading";

@NgModule({
  imports: [
    LoginRoutingModule,
    SharedModule,
    SharedModelModule,
    NgxLoadingModule.forRoot({}),
  ],
  declarations: [
    routedComponents
  ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/login/login.module.ts